/**
 * Whether a wizard step circle is locked. Vendors may click back to earlier
 * steps and up to (and including) the first step with unfinished required
 * questions, but not past it — enforcing stage-by-stage completion.
 * firstIncompleteIndex is -1 when every step is complete (nothing locked).
 */
export function isStepLocked(index: number, firstIncompleteIndex: number): boolean {
  return firstIncompleteIndex >= 0 && index > firstIncompleteIndex;
}
